import { useQuery } from '@tanstack/react-query';
import PetProfile from '../../happypaws-shared/src/Pets/models/PetProfile';
import { api } from '../../services/api';

export const useGetPet = (petId: string) => {
  return useQuery({
    queryKey: ['pet', petId],
    queryFn: async () => {
      const response = await api.get<PetProfile>(`/pets/${petId}`);
      return response.data;
    },
    enabled: !!petId,
    staleTime: 5 * 60 * 1000,
  });
};
